import { Component, Input } from '@angular/core';

import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';
import { Dashboard } from '../../../../../providers/bridge-api/dashboard.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-dashboard-option-metadata',
  templateUrl: './dashboard-option-metadata.component.html',
  styleUrls: ['./dashboard-option-metadata.component.scss'],
  standalone: false,
})
export class DashboardOptionMetadataComponent {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  @Input() dashboard: Dashboard;
}
